import { useIntl } from 'react-intl'

import type { OrchestratedListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { ShipmentEnums } from '@b-stock/fe-core/locale'

const ShippingAvailableText = ({
  shipping,
}: {
  shipping: OrchestratedListingDetails['shipping']
}) => {
  const { formatMessage } = useIntl()

  return (
    <span>
      {(shipping?.allowedShipmentTypes ?? [])
        .map((type) => ShipmentEnums.ShipmentType.format(formatMessage, type))
        .join(', ')}
      {shipping?.allowedShipmentTypes?.length === 1 && (
        <FormattedMessage id="ShippingAvailable.only" />
      )}
    </span>
  )
}

const ShippingAvailable = ({
  shipping,
}: {
  shipping?: OrchestratedListingDetails['shipping']
}) => {
  return (
    <FormattedMessage
      id="ShippingAvailable.available"
      values={{
        available: <ShippingAvailableText shipping={shipping} />,
      }}
    />
  )
}

export default ShippingAvailable
